import { render, staticRenderFns } from "./ExternalProjectManagement.vue?vue&type=template&id=451159be&scoped=true&"
import script from "./ExternalProjectManagement.vue?vue&type=script&lang=ts&"
export * from "./ExternalProjectManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalProjectManagement.vue?vue&type=style&index=0&id=451159be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451159be",
  null
  
)

export default component.exports